function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,87.45098%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 3.644531 3.644531 L 23.355469 3.644531 L 23.355469 23.355469 L 3.644531 23.355469 Z M 3.644531 3.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.828125 20.117188 L 10.335938 19.203125 C 10.628906 19.722656 10.890625 20.152344 11.523438 20.152344 C 12.132812 20.152344 12.515625 19.914062 12.515625 18.984375 L 12.515625 12.695312 L 14.367188 12.695312 L 14.367188 19.019531 C 14.367188 20.9375 13.246094 21.8125 11.605469 21.8125 C 10.125 21.8125 9.265625 21.042969 8.828125 20.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.378906 19.914062 L 16.886719 19.039062 C 17.285156 19.6875 17.796875 20.164062 18.710938 20.164062 C 19.476562 20.164062 19.96875 19.78125 19.96875 19.25 C 19.96875 18.613281 19.46875 18.390625 18.621094 18.019531 L 18.15625 17.820312 C 16.820312 17.253906 15.929688 16.535156 15.929688 15.027344 C 15.929688 13.640625 16.988281 12.582031 18.640625 12.582031 C 19.820312 12.582031 20.667969 12.992188 21.277344 14.0625 L 19.832031 14.984375 C 19.515625 14.417969 19.175781 14.191406 18.644531 14.191406 C 18.105469 14.191406 17.761719 14.535156 17.761719 14.984375 C 17.761719 15.542969 18.105469 15.765625 18.898438 16.109375 L 19.363281 16.308594 C 20.941406 16.984375 21.828125 17.667969 21.828125 19.21875 C 21.828125 20.886719 20.515625 21.800781 18.757812 21.800781 C 17.03125 21.8125 15.917969 20.988281 15.378906 19.914062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.643d032f82ea9cd2e5adf172ff223fe3.svg";
export { ForwardRef as ReactComponent };